import React from "react";
import "./advisors.css";
import img1 from "../../images/matangi.jpg";
import img2 from "../../images/esterNew.jpg";
import img3 from "../../images/shyamala1.jpg";
import img4 from "../../images/left-top.png";
import img5 from "../../images/right-bottom.png";
import img6 from "../../images/Renu_Sud_Karnad.jpg";



export class advisors extends React.Component {
  constructor(args) {
    super(args);
    this.state;
  }

  render() {
    return (
      <div className="section__content">
        <div className="advisors-wrapper" id="advisors">
          <div className="container">
            <div className="advisors-heading">
              <h1>Advisory Board</h1>
            </div>
            <div className="into_text">
              The Winpe ProClub Advisory Board will steer the mentorship program
              in achieving its objectives. We are proud to have the advice and
              guidance from exceptional leaders.
            </div>
            <div className="row card-wrapper">
           
              <div className="col-md-6">
                <div className="card">
                  <div className="top-section">
                    <a href="/matangi-gowrishankar/">
                      <img src={img1} alt="" />
                    </a>
                    <h3>Matangi Gowrishankar</h3>
                    <p className="post">Independent Director</p>
                    <p>Strategic Advisor & Certified Coach </p>
                  </div>
                </div>
              </div>
            
             
              <div className="col-md-6">
                <div className="card">
                  <div className="top-section">
                    <a href="/shyamala-gopinath/">
                      <img src={img3} alt="" />
                    </a>
                    <h3>Shyamala Gopinath</h3>
                    <p className="post">Former Deputy Governer, RBI, </p>
                    <p>Non-Executive Chairperson, HDFC Bank Ltd</p>
                  </div>
                </div>
              </div>
            
            </div>
          </div>
        </div>
        
      </div>
    );
  }
}

export default advisors;



// WEBPACK FOOTER //
// ./src/components/advisors/index.jsx